import Collapse from './src/collapse';

Collapse.install = function(Vue) {
  Vue.component(Collapse.name, Collapse);
};

export default Collapse;




// WEBPACK FOOTER //
// ./src/components/collapse/index.js